import getFormFields from 'cerebral-module-forms/helpers/getFormFields'

export default function isValidFormExcludeHidden(form) {
  var formFields = getFormFields(form)
  return Object.keys(formFields).reduce(function(isValid, formFieldKey) {
    if (!formFields[formFieldKey].isValid && !formFields[formFieldKey].hidden) {
      return false
    }
    return isValid
  }, true)
}



// WEBPACK FOOTER //
// ./src/modules/login/helpers/isValidFormExcludeHidden.js